import React from 'react';
import Layout from '../../components/Layout';

const Orders = () => {
  return <Layout>Orders</Layout>;
};

export default Orders;
